import { SkeletonTypes, UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import React from 'react';

export const ColoredSkeleton = (props: SkeletonTypes.Props) => (
  <UI.Skeleton
    height={Typography['fontsize.lg']}
    borderRadius={BoxRadius.sm}
    endColor="brand.primary.lightest"
    {...props}
  />
);

export const SkeletonItemDesktop: React.FC = () => {
  return (
    <VStack
      minW="container"
      maxWidth={900}
      alignSelf={'center'}
      flex={1}
      w={'full'}
      space="inline.xxxs"
      pt="inline.xs"
      px="inline.xxxs"
      justifyContent={'center'}>
      <HStack flexDirection={'row'} flex={1} w={'full'} space="inline.xxxs">
        <VStack
          flex={1}
          h="inline.sm"
          flexDirection={'column'}
          borderRadius={BoxRadius.sm}
          space="inline.xxxs">
          {Array.from({ length: 5 }, (_, i) => i).map((item) => (
            <ColoredSkeleton key={item.toString()} height={item === 0 ? '500px' : 'inline.sm'} />
          ))}
        </VStack>

        <VStack space="inline.xxxs" flexShrink={0} minWidth={360} pt="stack.xxs">
          <VStack space="inline.xxxs" w="full">
            <VStack space="inline.sm">
              <HStack space="inline.quarck">
                <UI.Heading testId="offer-summary-header" size="h3" color="brand.primary.principal">
                  Ordem
                </UI.Heading>
                <ColoredSkeleton width="80px" />
              </HStack>

              <VStack space="stack.quarck">
                <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                  Valor da operação
                </UI.Text>
                <ColoredSkeleton height={Typography['fontsize.xl']} width="120px" />
              </VStack>
            </VStack>

            {Array.from({ length: 4 }, (_, i) => i).map((item) => (
              <HStack key={item.toString()} justifyContent="space-between" w="full">
                <ColoredSkeleton width="60%" />
                <ColoredSkeleton width="20%" />
              </HStack>
            ))}
          </VStack>
          <HStack w="full">
            <ColoredSkeleton height="inline.sm" />
          </HStack>
        </VStack>
      </HStack>

      {/* <HStack py='inline.xxxs' borderRadius={BoxRadius.sm}>
        <Skeleton
          h={Typography['fontsize.xxl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack> */}
    </VStack>
  );
};
